export default function ConsoleUserRow({ consoleUser, onEdit }) {
  const privilege =
    consoleUser.userType === "consoleAdministrator"
      ? "administrator"
      : consoleUser.userType === "consoleTeacher"
        ? "lehrer"
        : "auditor";

  return (
    <tr>
      <td>{consoleUser.name}</td>
      <td>{consoleUser.email}</td>
      <td>{privilege}</td>
      {onEdit ? (
        <td className="text-nowrap">
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => onEdit(consoleUser)}>
            Bearbeiten
          </button>
        </td>
      ) : null}
    </tr>
  );
}
